import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5a48db7f&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5a48db7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a48db7f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a48db7f')) {
      api.createRecord('5a48db7f', component.options)
    } else {
      api.reload('5a48db7f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5a48db7f&scoped=true&", function () {
      api.rerender('5a48db7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/modules/supplier-store-dialog/index.vue"
export default component.exports